import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Buefy from 'buefy'
import './assets/scss/app.scss'

import * as firebase from 'firebase/app'
import 'firebase/auth'
// Required for side-effects
import 'firebase/firestore'

import store from './store'

const config = {
  apiKey: 'AIzaSyBwc3-q7nHHtbOOuUg3zDfmawmToqYSQ88',
  authDomain: 'wedding.mogensen.xyz',
  databaseURL: 'https://mogensen-boyle.firebaseio.com',
  projectId: 'mogensen-boyle',
  storageBucket: 'mogensen-boyle.appspot.com',
  messagingSenderId: '818650541142'
}

Vue.use(Buefy, {
  defaultIconPack: 'fa'
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
  store,

  created () {
    firebase.initializeApp(config)
    firebase.auth().onAuthStateChanged(user => store.commit('updateUser', { user }))
  }
}).$mount('#app')
